import { Button } from 'components/v2/Buttons/Button/Button';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1em;
`;

export const ProfileInfo = styled.div`
  display: flex;
  align-items: center;
`;

export const Greeting = styled.div`
  color: ${({ theme }) => theme.colors.neutral.primaryNavy};

  > div:first-child > h1 {
    @media ${({ theme }) => theme.queries.mobile} {
      font-size: 14px;
      font-weight: 400;
    }
  }
`;

export const GreetingLine = styled.div`
  > h1 {
    font-weight: 700;
    margin-left: 24px;

    @media ${({ theme }) => theme.queries.minLargeDesktop} {
      font-size: 32px;
      margin-left: 4px;
    }

    @media ${({ theme }) => theme.queries.mobile} {
      font-size: 18px;
    }
  }
`;

export const BookingButton = styled(Button)`
  margin-left: 20px;
`;
